
import { ExternalLink } from "../../../../Utils/link-helper";


export const ExternalNavigationLinks = ({ linkText, to, key }) => {

    return <ExternalLink href={to}>{linkText}</ExternalLink>;
}

